import { Redirect } from 'react-router'
import { branch, renderComponent, renderNothing } from 'recompose'

import { queryPosts } from 'wordpress/actions'
import Meta from 'shared/components/Meta'
import { loadOnMount } from 'shared/hoc'
import { withMeta, createPath, withLanguage, Route, Link } from 'i18n/utils'

import { locationBySlugSelector, locationsPendingSelector } from '../selectors'
import Breadcrumbs from './Breadcrumbs'
import ContentTab from './ContentTab'
import '../styles/location.scss'

const LocationOverviewTab = ({ location: { address, contactHours, description, fax, name, phone } }) => (
    <div className="overview">
        <Meta {...location} />

        <div className="container no-gutters p-0">
            <h1 className="text-center">{name}</h1>

            <div className="row no-gutters details">
                <div className="col-sm-6 col-xs-12 contacts">
                    {address && (
                        <span>
                            <i className="icon-house" />
                            <span>{address}</span>
                        </span>
                    )}
                    {phone && (
                        <span>
                            <i className="icon-phone" />
                            <span>{phone}</span>
                        </span>
                    )}
                    {fax && (
                        <span>
                            <i className="icon-fax" />
                            <span>{fax}</span>
                        </span>
                    )}
                </div>

                <div className="col-sm-6 col-xs-12 availability">
                    <span>
                        <i className="icon-time" />
                        <ul className="opening-hours">
                            {contactHours.map((o, i) => (
                                <li key={i}>
                                    <span className="text-left">{o.label}</span>
                                    <span className="text-right">{o.value}</span>
                                </li>
                            ))}
                        </ul>
                    </span>
                </div>
            </div>
        </div>

        {description && <div className="description mb-5" dangerouslySetInnerHTML={{ __html: description }} />}
    </div>
)

const LocationView = ({ location }) => (
    <div className="container location">
        <div className="react-tabs mb-3">
            <div className="tabs">
                {location.tabs.map(tab => (
                    <Link navLink className="tab" to={`/on-street/${location.slug}/${tab.page}`} key={tab.page}>
                        <span>{tab.label}</span>
                    </Link>
                ))}
            </div>
        </div>

        <Breadcrumbs location={location} />

        <div className="container-content mb-3">
            <Route exact path="/on-street/:slug" render={() => <LocationOverviewTab location={location} />} />
            <Route
                exact
                path="/on-street/:slug/:pageId"
                render={props => <ContentTab {...props} key={props.match.params.pageId} />}
            />
        </div>
    </div>
)

const RedirectToActualLanguage = ({ language, location }) => (
    <Redirect replace to={createPath(language, `/on-street/${location.translations[language]}`)} />
)

export default compose(
    withLanguage,
    connect(
        createStructuredSelector({
            location: locationBySlugSelector,
            pending: locationsPendingSelector,
        }),
        { queryPosts }
    ),
    loadOnMount('queryPosts', props => ['locations', { slug: props.match.params.slug }]),
    branch(props => !props.location, renderNothing),
    withMeta(({ location }) => ({ title: location ? location.name : null })),
    branch(
        ({ language, location }) => location.translations[language] !== location.slug,
        renderComponent(RedirectToActualLanguage)
    )
)(LocationView)
